.container {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 164px;
    gap: 4px;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.container::-webkit-scrollbar {
    display: none;
}

.stage-wrapper {
    scroll-snap-align: center;
    overflow: visible;
}
